<template>
  <form ref="formRef" novalidate @submit.prevent="saveDirecciones" class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
    <div class="card-body w-100">
      <div class="d-flex justify-content-between align-items-center mb-3 w-100">
        <h2 class="fw-bold fs-5 m-0 mt-1">{{ $t('direcciones') }}</h2>
        <img v-if="loading" src="@/assets/LOADING.gif" style="width: 30px;" alt="Cargando..." />
        <button @click="isEditingDirecciones = true" v-if="(hasEditarPersonaPermission && !isEditingDirecciones) || isEditingPerfil" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>
      </div>
      <div v-if="!isEditingDirecciones">
        <div v-for="(direccion, index) in direcciones" :key="direccion.IdDireccion || index">
          <div class="d-flex align-items-end gap-2 mb-3">
            <h5 class="m-0">{{ $t('direccion') }} {{ index + 1 }} - {{ $t(direccion?.TipoDireccion?.toLowerCase() || 'particular') }}</h5>
            <p class="m-0 texto-secundario fs-7">{{ direccion.EsPrincipal ? '('+$t('principal') + ')' : '' }}</p>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('provincia') }}</label>
              <p class="m-0">{{ direccion.NombreProvincia || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('localidad') }}</label>
              <p class="m-0">{{ direccion.NombreLocalidad || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('calle') }}</label>
              <p class="m-0">{{ direccion.Calle || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('nro') }}</label>
              <p class="m-0">{{ direccion.Nro || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3" v-if="direccion.Piso">
              <label class="m-0 texto-secundario fs-7">{{ $t('piso') }}</label>
              <p class="m-0">{{ direccion.Piso || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3" v-if="direccion.Depto">
              <label class="m-0 texto-secundario fs-7">{{ $t('departamento') }}</label>
              <p class="m-0">{{ direccion.Depto || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('codigoPostal') }}</label>
              <p class="m-0">{{ direccion.CodigoPostal || 'N/A' }}</p>
            </div>
            <div class="col-md-6 mb-3" v-if="direccion.Barrio">
              <label class="m-0 texto-secundario fs-7">{{ $t('barrio') }}</label>
              <p class="m-0">{{ direccion.Barrio || 'N/A' }}</p>
            </div>
          </div>
          <div v-if="direccion.PersonasEnEstaDireccion && direccion.PersonasEnEstaDireccion.length > 0" class="mb-1">
            <label class="m-0 texto-secundario fs-7">{{ $t('direccionCompartidaCon') }}</label>
            <div class="d-flex flex-wrap gap-2">
              <div v-for="persona in direccion.PersonasEnEstaDireccion" :key="persona.IdPersona" class="d-flex align-items-center gap-2 cursor-pointer bg-goethe-accent-claro-2 rounded-pill p-1 pe-2" @click="goToPersona(persona.IdPersona)">
                <img :src="persona.FotoUrl || '/assets/default-avatar.png'" alt="Foto de perfil" class="rounded-circle" style="width: 30px; height: 30px; object-fit: cover;" />
                <span class="text-decoration-none"> {{ persona.Apellido }} {{ persona.Nombre }}</span>
              </div>
            </div>
          </div>
          <hr v-if="index +1 < direcciones?.length" class="my-3 borde-gris">
        </div>
      </div>

      <div v-if="isEditingDirecciones">
        <div v-for="(direccion, index) in localDirecciones" :key="direccion.IdDireccion || index">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex justify-content-between align-items-center gap-2">
              <h5 class="m-0">{{ $t('direccion') }} {{ index + 1 }} -</h5>
              <div class="d-flex flex-row">
                <div class="select-wrapper w-100">
                  <select v-model="direccion.TipoDireccion" class="form-select fondo-principal sombra-sm">
                    <option value="Particular">{{ $t('particular') }}</option>
                    <option value="Laboral">{{ $t('laboral') }}</option>
                    <option value="Otro">{{ $t('otro') }}</option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                </div>
              </div>
              <div class="d-flex align-items-center gap-1 ms-2">
                <input type="checkbox" v-model="direccion.EsPrincipal" @change="setPrincipal(direccion)" class="form-check-input m-0" :id="'principal-' + index">
                <label class="form-check-label texto-secundario fs-7 m-0" :for="'principal-' + index">{{ $t('principal') }}</label>
              </div>
            </div>
            <button @click="removeDireccion(index)" class="btn btn-danger btn-sm" type="button">{{ $t('eliminar') }}</button>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('provincia') }} *</label>
              <div class="select-wrapper w-100 position-relative">
                <select v-model="direccion.tempIdProvincia" class="form-select fondo-principal sombra-sm" @change="fetchLocalidadesForDireccion(direccion)" required>
                  <option v-for="provincia in provincias" :key="provincia.IdProvincia" :value="provincia.IdProvincia">{{ provincia.NombreProvincia }}</option>
                </select>
                <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                </svg>
                <div class="invalid-feedback position-absolute" style="position: absolute !important;">{{ $t('provinciaRequerida') }}</div>
              </div>
            </div>
            <div class="col-md-6 mb-3 position-relative">
              <label class="m-0 texto-secundario fs-7">{{ $t('localidad') }} *</label>
              <input type="text" v-model="direccion.searchQueryLocalidad" class="form-control fondo-principal sombra-sm" @input="filterLocalidadForDireccion(direccion)" required />
              <ul v-if="direccion.filteredLocalidad && direccion.filteredLocalidad.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 94%; top: 100%; max-height: 200px; overflow-y: auto;">
                <li v-for="Localidad in direccion.filteredLocalidad" :key="Localidad.IdLocalidad" class="list-group-item list-group-item-action" @click="selectLocalidadForDireccion(direccion, Localidad)">
                  {{ Localidad.NombreLocalidad }}
                </li>
              </ul>
              <div class="invalid-feedback">{{ $t('localidadRequerida') }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('calle') }} *</label>
              <input type="text" v-model="direccion.Calle" class="form-control fondo-principal sombra-sm" maxlength="200" required />
              <div class="invalid-feedback">{{ $t('calleRequerida') }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('nro') }} *</label>
              <input type="text" v-model="direccion.Nro" class="form-control fondo-principal sombra-sm" maxlength="200" required />
              <div class="invalid-feedback">{{ $t('nroRequerido') }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('piso') }}</label>
              <input type="number" v-model="direccion.Piso" class="form-control fondo-principal sombra-sm" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('departamento') }}</label>
              <input type="text" v-model="direccion.Depto" class="form-control fondo-principal sombra-sm" maxlength="10" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('codigoPostal') }} *</label>
              <input type="number" v-model="direccion.CodigoPostal" class="form-control fondo-principal sombra-sm" required />
              <div class="invalid-feedback">{{ $t('codigoPostalRequerido') }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="m-0 texto-secundario fs-7">{{ $t('barrio') }}</label>
              <input type="text" v-model="direccion.Barrio" class="form-control fondo-principal sombra-sm" maxlength="100" />
            </div>
          </div>
          <div v-if="direccion.PersonasEnEstaDireccion && direccion.PersonasEnEstaDireccion.length > 0" class="mb-3">
            <label class="m-0 texto-secundario fs-7">{{ $t('direccionSeLeActualizaraTambienA') }}:</label>
            <div class="d-flex flex-wrap gap-2">
              <div v-for="persona in direccion.PersonasEnEstaDireccion" :key="persona.IdPersona" class="d-flex align-items-center gap-2 cursor-pointer bg-goethe-accent-claro-2 rounded-pill p-1 pe-2" @click="goToPersona(persona.IdPersona)">
                <img :src="persona.FotoUrl || '/assets/default-avatar.png'" alt="Foto de perfil" class="rounded-circle" style="width: 30px; height: 30px; object-fit: cover;" />
                <span class="text-decoration-none"> {{ persona.Apellido }} {{ persona.Nombre }}</span>
              </div>
            </div>
          </div>
          <hr v-if="index +1 < localDirecciones?.length" class="my-2 borde-gris">
        </div>
        <button @click="addDireccion" class="btn success-btn fs-6 px-2 p-1 d-flex align-items-center gap-2" type="button">
          <svg width="20" height="20" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M12 6V18" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('agregar') }}
        </button>
      </div>
      <div v-if="isEditingDirecciones" class="d-flex justify-content-end gap-2 mt-3">
        <button class="btn success-btn sombra-sm d-flex align-items-center gap-2" type="submit" :disabled="loadingDirecciones">
          {{ $t('guardarCambios') }}
          <img v-if="loadingDirecciones" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </button>
        <button class="btn secondary-btn sombra-sm" type="button" @click="isEditingDirecciones = false">{{ $t('cancelar') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { ref, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import api from '@/services/api';

export default {
  name: 'DireccionesSection',
  props: {
    persona: {
      type: Object,
      default: () => ({})
    },
    hasEditarPersonaPermission: {
      type: Boolean,
      default: false
    },
    isEditingPerfil: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n();
    const router = useRouter();
    const isEditingDirecciones = ref(false);
    const loading = ref(false);
    const loadingDirecciones = ref(false);
    const loadingProvinciasArg = ref(false);
    const loadingLocalidades = ref(false);
    const provincias = ref([]);
    const localidades = ref([]);
    const provinciaLocalidadesMap = ref({});
    const searchQueryLocalidad = ref('');
    const filteredLocalidad = ref([]);
    const direcciones = ref([]);
    const localDirecciones = ref([]);
    const errors = ref({});
    const formRef = ref(null);

    const fetchProvinciasArg = async () => {
      try {
        loadingProvinciasArg.value = true;
        const response = await api.get(`api/ExtrasPersonas/Provincias/ByPais/1F3517DF-5C00-471B-8883-91D73A902EB4`);
        provincias.value = response.data;
        loadingProvinciasArg.value = false;
      } catch (error) {
        console.error('Error al obtener provincias:', error);
        loadingProvinciasArg.value = false;
      }
    };

    const fetchDirecciones = async (personaId) => {
      try {
        loading.value = true;
        const response = await api.get(`api/Persona/${personaId}/direcciones`);
        direcciones.value = response.data;
        localDirecciones.value = response.data.map(d => ({
          ...d,
          searchQueryLocalidad: d.NombreLocalidad || '',
          filteredLocalidad: [],
          tempIdProvincia: d.IdProvincia || null
        }));
        // Fetch localidades for each address with a province
        for (const direccion of localDirecciones.value) {
          if (direccion.tempIdProvincia) {
            await fetchLocalidadesForDireccion(direccion);
          }
        }
        console.log(direcciones.value)
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.error('Error al obtener direcciones:', error);
        direcciones.value = [];
        localDirecciones.value = [];
      }
    };


    const addDireccion = () => {
      const hasPrincipal = localDirecciones.value.some(direccion => direccion.EsPrincipal);
      localDirecciones.value.push({
        IdDireccion: null,
        Calle: '',
        Nro: '',
        Piso: null,
        Depto: '',
        CodigoPostal: '',
        Barrio: '',
        IdLocalidad: null,
        NombreLocalidad: '',
        IdProvincia: null,
        NombreProvincia: '',
        EsPrincipal: !hasPrincipal,
        TipoDireccion: 'Particular',
        PersonasEnEstaDireccion: [],
        searchQueryLocalidad: '',
        filteredLocalidad: [],
        tempIdProvincia: null
      });
    };

    const removeDireccion = (index) => {
      localDirecciones.value.splice(index, 1);
    };

    const setPrincipal = (selectedDireccion) => {
      localDirecciones.value.forEach(direccion => {
        if (direccion !== selectedDireccion) {
          direccion.EsPrincipal = false;
        }
      });
    };

    const validateDirecciones = async () => {
      errors.value = {};
      let isValid = true;
      localDirecciones.value.forEach((direccion, index) => {
        const dirErrors = {};
        if (!direccion.tempIdProvincia) {
          dirErrors.tempIdProvincia = t('provinciaRequerida');
          isValid = false;
        }
        if (!direccion.IdLocalidad) {
          dirErrors.IdLocalidad = t('localidadRequerida');
          isValid = false;
        }
        if (!direccion.Calle || direccion.Calle.trim() === '') {
          dirErrors.Calle = t('calleRequerida');
          isValid = false;
        }
        if (!direccion.Nro || direccion.Nro.trim() === '') {
          dirErrors.Nro = t('nroRequerido');
          isValid = false;
        }
        if (!direccion.CodigoPostal) {
          dirErrors.CodigoPostal = t('codigoPostalRequerido');
          isValid = false;
        }
        if (Object.keys(dirErrors).length > 0) {
          errors.value[index] = dirErrors;
        }
      });
      await nextTick();
      if (!isValid) {
        formRef.value?.classList.add('was-validated');
      } else {
        formRef.value?.classList.remove('was-validated');
      }
      return isValid;
    };

    const fetchLocalidadesForDireccion = async (direccion) => {
      try {
        if (!provinciaLocalidadesMap.value[direccion.tempIdProvincia]) {
          const response = await api.get(`api/ExtrasPersonas/Localidades/ByProvincia/` + direccion.tempIdProvincia);
          provinciaLocalidadesMap.value[direccion.tempIdProvincia] = response.data;
        }
        direccion.localidades = provinciaLocalidadesMap.value[direccion.tempIdProvincia];
      } catch (error) {
        console.error('Error al obtener localidades:', error);
      }
    };

    const filterLocalidadForDireccion = (direccion) => {
      if (direccion.searchQueryLocalidad === '') {
        direccion.filteredLocalidad = [];
        return;
      }

      const query = normalizeString(direccion.searchQueryLocalidad);
      const lowerCaseQuery = query.toLowerCase();

      const queryWords = lowerCaseQuery.split(' ').filter(word => word.length > 0);

      const combinedResults = direccion.localidades?.filter(Localidad => {
        const nombreNormalized = normalizeString(Localidad.NombreLocalidad);
        const nombreLowerCase = nombreNormalized.toLowerCase();

        if (nombreLowerCase.includes(lowerCaseQuery)) {
          return true;
        }

        return queryWords.every(word => nombreLowerCase.includes(word));
      });

      direccion.filteredLocalidad = combinedResults;
    };

    const selectLocalidadForDireccion = (direccion, Localidad) => {
      direccion.searchQueryLocalidad = `${Localidad.NombreLocalidad}`;
      direccion.filteredLocalidad = [];
      direccion.IdLocalidad = Localidad.IdLocalidad;
      direccion.NombreLocalidad = Localidad.NombreLocalidad;
      direccion.IdProvincia = Localidad.IdProvincia;
      direccion.NombreProvincia = Localidad.NombreProvincia;
    };

    const normalizeString = (str) => {
      if (typeof str !== 'string') {
        return str;
      }
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace("ñ", "n");
    };

    const goToPersona = async (userId) => {
      await router.push(`/personas/verDatosPersona?id=${userId}`);
    };

    const saveDirecciones = async () => {
      // Vacia searchQueryLocalidad si no se seleccionó una localidad válida
      localDirecciones.value.forEach(direccion => {
        if (!direccion.IdLocalidad) {
          direccion.searchQueryLocalidad = '';
        }
      });
      if (!(await validateDirecciones())) {
        return;
      }
      const hasPrincipal = localDirecciones.value.some(direccion => direccion.EsPrincipal);
      if (!hasPrincipal && localDirecciones.value.length > 0) {
        alert(t('alMenosUnaDireccionPrincipal'));
        return;
      }
      loadingDirecciones.value = true;
      try {
        const direccionesData = localDirecciones.value.map(direccion => ({
          IdDireccion: direccion.IdDireccion,
          TipoDireccion: direccion.TipoDireccion,
          EsPrincipal: direccion.EsPrincipal,
          Calle: direccion.Calle,
          Nro: direccion.Nro,
          Piso: direccion.Piso === "" ? null : direccion.Piso,
          Depto: direccion.Depto,
          CodigoPostal: direccion.CodigoPostal === "" ? null : direccion.CodigoPostal,
          Barrio: direccion.Barrio,
          IdLocalidad: direccion.IdLocalidad
        }));
        await api.put(`api/Persona/${props.persona.IdPersona}/direcciones`, direccionesData);
        isEditingDirecciones.value = false;
        fetchDirecciones(props.persona.IdPersona)
        //emit('updated');
      } catch (error) {
        console.error('Error al guardar direcciones:', error);
        alert('Hubo un problema al guardar las direcciones.');
      } finally {
        loadingDirecciones.value = false;
      }
    };

    watch(() => props.persona.IdPersona, (newIdPersona) => {
      if (newIdPersona) {
        fetchDirecciones(newIdPersona);
      }
    }, { immediate: true });

    onMounted(async () => {
      await fetchProvinciasArg();
    });

    return {
      t,
      isEditingDirecciones,
      loadingDirecciones,
      loadingProvinciasArg,
      loadingLocalidades,
      provincias,
      localidades,
      provinciaLocalidadesMap,
      searchQueryLocalidad,
      filteredLocalidad,
      direcciones,
      localDirecciones,
      fetchDirecciones,
      fetchProvinciasArg,
      addDireccion,
      removeDireccion,
      fetchLocalidadesForDireccion,
      filterLocalidadForDireccion,
      selectLocalidadForDireccion,
      normalizeString,
      goToPersona,
      saveDirecciones,
      setPrincipal,
      validateDirecciones,
      errors,
      loading,
      formRef,
    };
  },
};
</script>

<style>
</style>